import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/home';
import Container from '../../containers/app';
import Root from '../../components/root';

export default function PageHome() {
  return (
    <Root title={PAGE_TITLE.HOME}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
